import classNames from 'classnames'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './FaqAnswerList.module.scss'
import { convertStringToLink } from '../../helpers/text'
import { SvgChevron } from '../ui/svg-icons'

function FaqAnswerList({ className, questions, name, sectionId, ...rest }) {
  return (
    <div className={classNames(styles.category, className)} {...rest}>
      {name && <h3 className={styles.categoryTitle}>{name}</h3>}

      {questions?.map(({ id, title }) => {
        const titlePath = convertStringToLink(title)

        return (
          <div key={id} className={styles.question}>
            <Link to={`/${sectionId}/question/${id}-${titlePath}`} key={id}>
              {title}
            </Link>
            <SvgChevron className={styles.svg} />
          </div>
        )
      })}
    </div>
  )
}

FaqAnswerList.propTypes = {
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      body: PropTypes.string.isRequired,
    })
  ).isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
}

export default FaqAnswerList
